import * as React from 'react';
import { Modal } from 'antd';

const codes = {
  'orderId': 'insert id of order',
  'orderNumber': 'insert number of order',
  'email': 'insert email of order customer',
  'phone': 'insert phone of order customer',
  'addressLine1': 'insert delivery street addres of order',
  'addressLine2': 'insert delivery address line 2 of order',
  'city': 'insert delivery city of order',
  'zip': 'insert delivery zip code of order',
  'countyState': 'insert delivery county / state of order',
  'country': 'insert delivery country of order',
  'total': 'insert total amount of items in order',
  'shippingTrackingLink': 'insert shipping tracking link of order',
  'paymentTotal': 'insert paymant price of order',
  'deliveryTotal': 'insert shipping price of order',
  'orderTotal': 'insert total price of order',
  'linkOrderDetail': 'insert link to order detail for customer',
};

const invoiceCodes = {
  'invoiceNumber': 'insert number of invoice',
};

const proformaCodes = {
  'proformaNumber': 'insert number of proforma',
};

export const Documentation = (props: any) => {
  return (
    <Modal
      title="Letter data documentation"
      visible={true}
      width={600}
      onOk={() => props.onClose()}
      onCancel={() => props.onClose()}
    >
      <h3><i>Letters for states</i></h3>
      <h3 style={{ padding: 0, margin: 0, paddingBottom: 10 }}>Data of order</h3>

      {Object.keys(codes).map((code: string, index: number) => (
        <div key={index}>
          <label 
            style={{ 
              width: 200, 
              textAlign: 'right',
              display: 'inline-block',
              fontWeight: 'bold'
            }}
          >
            {`{${code}}`}
          </label>
          <span> - {codes[code]}</span>
        </div>
      ))}

      <h3 style={{ padding: 0, margin: 0, paddingTop: 15, paddingBottom: 10 }}>Data of invoice</h3>

      {Object.keys(invoiceCodes).map((code: string, index: number) => (
        <div key={index}>
          <label 
            style={{ 
              width: 200, 
              textAlign: 'right',
              display: 'inline-block',
              fontWeight: 'bold'
            }}
          >
            {`{${code}}`}
          </label>
          <span> - {invoiceCodes[code]}</span>
        </div>
      ))}

      <h3 style={{ padding: 0, margin: 0, paddingTop: 15, paddingBottom: 10 }}>Data of proforma</h3>

      {Object.keys(proformaCodes).map((code: string, index: number) => (
        <div key={index}>
          <label 
            style={{ 
              width: 200, 
              textAlign: 'right',
              display: 'inline-block',
              fontWeight: 'bold'
            }}
          >
            {`{${code}}`}
          </label>
          <span> - {proformaCodes[code]}</span>
        </div>
      ))}

    <h3><i>Letters for product availability watch dog</i></h3>

    <h3>Products</h3>

    <div>
          <label 
            style={{ 
              width: 200, 
              textAlign: 'right',
              display: 'inline-block',
              fontWeight: 'bold'
            }}
          >
            {'{{{products}}}'}
          </label>
          <span> - insert list of products that are again available</span>
        </div>
    </Modal>
  );
}


// WEBPACK FOOTER //
// ./src/scenes/LetterData/LetterDataDetail/components/Documentation/Documentation.tsx